module.exports = __webpack_public_path__ + "img/151.c190e8a6.jpg";